import { render, staticRenderFns } from "./EstimateRequestDetails.vue?vue&type=template&id=22cd3362&scoped=true"
import script from "./EstimateRequestDetails.vue?vue&type=script&lang=js"
export * from "./EstimateRequestDetails.vue?vue&type=script&lang=js"
import style0 from "./EstimateRequestDetails.styles.scss?vue&type=style&index=0&id=22cd3362&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd3362",
  null
  
)

export default component.exports